import digitalData from 'digital-data';

export const questionsAndAnswers = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('submit-QA.click', ({ output = {} }) => {
    const ddoEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      content: {
        ugc: [{
          module: 'questions and answers',
          component: output?.component,
          element: 'submit'
        }]
      },
      eventInfo: {
        eventName: 'ugc click'
      }
    };
    (digitalData.event || []).push(ddoEvent);
  });
};